const ReactDataGrid = require('react-data-grid');
const React = require('react');

export default class ExportDataGrid extends React.Component {
  constructor(props, context) {
    super(props, context);
    window.ExportDataGrid=this;
    var rows=this.props.rows;
    var columns=this.props.columns;
    this.state = { rows:rows, selectedIndexes: [],columns:columns};
  }

  createRows = (numberOfRows) => {
    let rows = [];
    for (let i = 0; i < numberOfRows; i++) {
      rows[i] = this.createFakeRowObjectData(i);
    }
    return rows;
  };

  createFakeRowObjectData = (index,data) => {
    console.log(data);
    for(var i=0;i<data.length;i++){
      let rows = this.state.rows.slice();
      const index=this.state.rows.length;
      return {
        id: 'id_' + index,
        title: tableName[i],
        firstName: itemName[i],
        lastName: lastName[i],
    };
    }
    
  };

  getColumns = () => {
    let columns = this.state.columns.slice();
    return columns;
  };

  test=()=>{
    console.log('1');
  }

  

  handleGridRowsUpdated = ({ fromRow, toRow, updated }) => {
    let rows = this.state.rows.slice();

    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i];
      let updatedRow = $.extend(rowToUpdate,updated);
      rows[i] = updatedRow;
    }
    this.setState({ rows:rows});
  };

  handleAddRow = () => {
   let rows = this.state.rows.slice();
    for (let i = fromRow; i <= toRow; i++) {
      let rowToUpdate = rows[i];
      let updatedRow = $.extend(rowToUpdate,updated);
      rows[i] = updatedRow;
    }
    this.setState({ rows });
  };

  deleteRow=()=>{
   let rows=this.state.rows.slice();
   let selectedIndex=this.state.selectedIndexes[0];
   rows.splice(selectedIndex,1);
   this.setState({ rows:rows,selectedIndexes:[rows.length-1]});
  }

  getRowAt = (index) => {
    if (index < 0 || index > this.getSize()) {
      return undefined;
    }

    return this.state.rows[index];

  };

  getSize = () => {
    return this.state.rows.length;
  };

  rowClick = (index,record,proxy) =>{
    this.setState({ selectedIndexes:[index]});
  }

  updateColumns = (columns) =>
  {
    alert(223);
    this.props.columns = columns;
    this.setState();
  }

  handleGridSort = (sortColumn, sortDirection) => {
    const comparer = (a, b) => {
      if (sortDirection === 'ASC') {
        return (a[sortColumn] > b[sortColumn]) ? 1 : -1;
      } else if (sortDirection === 'DESC') {
        return (a[sortColumn] < b[sortColumn]) ? 1 : -1;
      }
    };
    
    const rows = sortDirection === 'NONE' ? this.state.rows.slice(0) : this.state.rows.sort(comparer);

    this.setState({ rows:rows });
  }

 componentDidUpdate=()=>{
  var columns=this.state.columns.slice();

 }

  render() {  
    return (

      <ReactDataGrid
        ref={ node => this.grid = node }
        onGridSort={this.handleGridSort}
        enableCellSelect={true}
        columns={this.props.columns}
        // columns={this.getColumns()}
        rowGetter={this.getRowAt}
        rowsCount={this.getSize()}
        onGridRowsUpdated={this.handleGridRowsUpdated}
        // toolbar={<Toolbar onAddRow={this.handleAddRow}/>}
        enableRowSelect={false}
        rowSelection={{
          showCheckbox: false,
          selectBy: {
            indexes: this.state.selectedIndexes
            
          }
        }}
        onRowClick={this.rowClick}//this.rowClick this.rowClick.bind(this)
        rowHeight={30}
        minHeight={375}
        rowScrollTimeout={500} 
        cellNavigationMode="loopOverRow"
       
        />);
  }
}



// WEBPACK FOOTER //
// ./src/menuCustom/ExportDataGrid.js